import React from 'react';
import { Link, useLocation } from 'react-router';
import { useAppContext } from '../../context/AppContext';
import { useAuth } from '../../context/AuthContext';
import useOrgRole from '../../hooks/useOrgRole';
import CrimsonLogo from '../CrimsonLogo';

export default function Header() {
  const ctx = useAppContext();
  const { user, signOut, org } = useAuth() || {};
  const { isAdmin, isBilling, isIT, isSuperAdmin } = useOrgRole();
  const isPilot = org?.plan === 'pilot';
  const location = useLocation();
  const toolResults = ctx?.toolResults;
  const history = ctx?.history || [];
  const savedCandidates = ctx?.savedCandidates || [];
  const hasAnyResults = !!(toolResults || history.length > 0);

  const navLink = (to, label, badge) => {
    const active = to === '/' ? location.pathname === '/' : location.pathname.startsWith(to);
    return (
      <Link
        to={to}
        style={{
          color: active ? '#e2e8f0' : '#94a3b8',
          background: active ? '#1e3a5f' : 'transparent',
          border: '1px solid ' + (active ? '#2d5a8e' : 'transparent'),
          borderRadius: 6,
          padding: '4px 12px',
          fontSize: 13,
          textDecoration: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          gap: 5,
          transition: 'all 0.15s',
        }}
      >
        {label}
        {badge != null && (
          <span
            style={{
              background: '#1e3a5f',
              color: '#94a3b8',
              borderRadius: 10,
              padding: '1px 6px',
              fontSize: 11,
              fontWeight: 600,
            }}
          >
            {badge}
          </span>
        )}
      </Link>
    );
  };

  return (
    <header
      style={{
        height: 56,
        background: '#0f1923',
        borderBottom: '1px solid #1e3a5f',
        display: 'flex',
        alignItems: 'center',
        padding: '0 24px',
        justifyContent: 'space-between',
        flexShrink: 0,
      }}
    >
      <Link
        to="/"
        style={{
          color: '#f43f5e',
          fontWeight: 700,
          fontSize: 16,
          textDecoration: 'none',
          letterSpacing: 0.3,
          display: 'inline-flex',
          alignItems: 'center',
          gap: 10,
        }}
      >
        <CrimsonLogo size={34} />
        CrimsonScan <span style={{ fontWeight: 300, opacity: 0.85, fontSize: 15, letterSpacing: 0.5 }}>— Spectra</span>
        {isPilot && (
          <span style={{
            background: '#f59e0b22', border: '1px solid #f59e0b55', borderRadius: 10,
            color: '#f59e0b', fontSize: 10, fontWeight: 700, padding: '2px 8px',
            letterSpacing: 0.5, marginLeft: 2,
          }}>
            PILOT
          </span>
        )}
      </Link>

      <nav style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        {navLink('/', 'Home')}
        {navLink('/search', 'Search')}
        {hasAnyResults && navLink('/results', 'Results')}
        {savedCandidates.length > 0 && navLink('/saved', 'Saved', savedCandidates.length)}
        {(isAdmin || isBilling || isIT || isSuperAdmin) && navLink('/admin', 'Admin Portal')}
        {navLink('/docs', 'Docs')}

        {user && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginLeft: 8, paddingLeft: 12, borderLeft: '1px solid #1e3a5f' }}>
            {user.photoURL
              ? <img src={user.photoURL} alt="" style={{ width: 26, height: 26, borderRadius: '50%', border: '1px solid #2d5a8e' }} />
              : <div style={{ width: 26, height: 26, borderRadius: '50%', background: '#1e3a5f', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, color: '#94a3b8', fontWeight: 600 }}>
                  {(user.displayName || user.email || '?')[0].toUpperCase()}
                </div>
            }
            <span style={{ color: '#94a3b8', fontSize: 12, maxWidth: 140, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {user.displayName || user.email}
            </span>
            <button
              onClick={signOut}
              style={{ background: 'none', border: '1px solid #334155', borderRadius: 5, color: '#64748b', fontSize: 12, padding: '3px 8px', cursor: 'pointer' }}
            >
              Sign out
            </button>
          </div>
        )}
      </nav>
    </header>
  );
}
